import backupPlan from "./backupPlan.component";
import backupPlanUrls from "./backupPlan.urls";
import BackupPlanTransforms from "./backupPlan.transforms";

const backupPlanModule = angular
  .module("app.components.backupPlan", [])
  .component("backupPlanPage", backupPlan)
  .service("BackupPlanTransforms", BackupPlanTransforms)
  .config(backupPlanUrls);

export default backupPlanModule;



// WEBPACK FOOTER //
// ./src/pages/backupPlan/backupPlan.module.js